import { ArrowRight, GcpBox, GcpTypography } from '@back-office/ui';
import Divider from '@material-ui/core/Divider';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionTransferProps, useStyles } from './transfer/shared';
import TransferDesktopView from './transfer/TransferDesktop';
import TransferTabletView from './transfer/TransferTablet';

const TransactionTransfer: FC<TransactionTransferProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <GcpBox className={classes.card}>
      <GcpBox display="flex" pl={3}>
        <GcpBox className={clsx(classes.upperGrid, classes.half)} pb={4} pt={4}>
          <GcpTypography variant="h2">
            {t('transaction_list.payer')}
          </GcpTypography>
        </GcpBox>
        {matches && (
          <GcpBox
            className={clsx(classes.relative, classes.half)}
            pb={4}
            pl={3}
            pt={4}
          >
            <GcpTypography variant="h2">
              {t('transaction_list.payee')}
            </GcpTypography>
            <GcpTypography className={classes.arrow} size={62}>
              <ArrowRight />
            </GcpTypography>
          </GcpBox>
        )}
      </GcpBox>
      <Divider className={classes.divider} />
      {matches && <TransferDesktopView {...props} />}
      {!matches && <TransferTabletView {...props} />}
    </GcpBox>
  );
};

export default TransactionTransfer;
